import React, { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { playSound } from '../../utils/soundManager';

const RewardModal = ({ badge, onClose }) => {
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    playSound('badge');
    
    // Generate confetti
    const confettiArray = [];
    for (let i = 0; i < 50; i++) {
      confettiArray.push({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 2,
        duration: 2 + Math.random() * 2
      });
    }
    setConfetti(confettiArray);

    // Auto close after 5 seconds
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      {/* Confetti */}
      {confetti.map((piece) => (
        <div
          key={piece.id}
          className="confetti"
          style={{
            left: `${piece.left}%`,
            animationDelay: `${piece.delay}s`,
            animationDuration: `${piece.duration}s`
          }}
        />
      ))}

      <div className="modal-content animate-scaleIn" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close hover-scale" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="reward-content">
          <div className="sparkles-container">
            <Sparkles className="sparkle sparkle-1 animate-pulse" size={32} />
            <Sparkles className="sparkle sparkle-2 animate-pulse" size={24} />
            <Sparkles className="sparkle sparkle-3 animate-pulse" size={28} />
          </div>

          <div className="badge-icon-large animate-bounce" style={{ fontSize: '6rem' }}>
            {badge.icon}
          </div>

          <h2 className="reward-title animate-slideInLeft">
            🎉 Congratulations! 🎉
          </h2>

          <h3 className="badge-name animate-slideInRight" style={{ color: '#f39c12' }}>
            {badge.name}
          </h3>

          <p className="badge-description animate-fadeIn">
            {badge.description}
          </p>

          <div className="reward-message animate-fadeIn">
            <p>You've earned a new badge! Keep up the great work!</p>
          </div>

          <button 
            className="action-button primary hover-lift btn-press"
            onClick={onClose}
            style={{ marginTop: '2rem' }}
          >
            Awesome!
          </button>
        </div>
      </div>
    </div>
  );
};

export default RewardModal;
